import i18next from 'i18next';

interface IError {
    code: number;
    message: string;
}

interface IErrorResponse {
    error: IError;
    data?: {
        error: IError;
    };
}

interface IPayload {
    response: IErrorResponse | string;
    xhr: any;
    message: string;
}

export const errorIds: { [code: number]: string } = {
    0: 'general_error',
    1: 'user_not_found',
    2: 'user_is_blocked',
    3: 'session_has_expired',
    4: 'invalid_credentials',
    5: 'invalid_parameters',
    6: 'service_communication_error',
    7: 'access_denied',
    8: 'custom_error',
    9: 'password_change_required',
    1040: 'players_exceed_limit',
};
export const CUSTOM_MESSAGE_CODE = 8;
export const DEFAULT_ERROR_ID = 'server_error';

function isIError(obj: any): obj is IError {
    return obj && typeof obj.code === 'number';
}

export const errorHandler = {
    getErrorText: (payload: IPayload): string => {
        let { response } = payload || {};
        let errorId: string | undefined;
        let errorText: string = i18next.t(DEFAULT_ERROR_ID);

        if (!response) {
            return errorText;
        }

        if (typeof response === 'string') {
            try {
                response = JSON.parse(response) as IErrorResponse;
            } catch {
                return errorText;
            }
        }

        const errorObject = (response && typeof response === 'object' && (
            (response as IErrorResponse).error ||
            ((response as IErrorResponse).data && (response as IErrorResponse).data?.error)
        )) || null;

        if (errorObject && typeof errorObject.message === 'string') {
            return errorObject.message || i18next.t(DEFAULT_ERROR_ID);
        }

        if (isIError(errorObject)) {
            const { code, message } = errorObject;
            if (code === CUSTOM_MESSAGE_CODE || code === 1040) {
                errorText = message || i18next.t(DEFAULT_ERROR_ID);
            } else {
                errorId = errorIds[code];
                errorText = errorId ? (i18next.t(errorId) || errorId) : i18next.t(DEFAULT_ERROR_ID);
            }
        }

        return errorText;
    },
};
